import { ClientCustomerRegistry } from '../interfaces/clientCustomerRegistry';


export class ClientCustomerRegistryModel implements ClientCustomerRegistry {
    AbiCode: string;
    CLIENTCODE: string;
    COMPANYCODE:  string;
    CUSTOMERCATEGORY:  string;
    CUSTOMERCODE:  string;
    CabCode:  string;
    ClientType:  string;
    CountryCode:  string;
    DeductionAccountPct: number;
    ExemptionVatCode:  string;
    ExpensesPayment: boolean;
    FLDOPVInterface: boolean;
    IncomePct: number;
    LastSaleDate:  string;
    NCCLIENTCODE:  string;
    RevocaDate:  string;
    STATISTICSALESCODE:  string;
    StampPayment: boolean;
    WorkshopCode:  string;
	constructor() { }
}
